import { render, staticRenderFns } from "./BackupForm.vue?vue&type=template&id=c7d2deb2&"
import script from "./BackupForm.vue?vue&type=script&lang=js&"
export * from "./BackupForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports